import { VersionInfoDto } from '@common-modules/navigation/models/version-info.dto';
import { Observable } from 'rxjs';
import { BaseService } from '../shared/base.service';

export abstract class SpinnerSplashService extends BaseService {
  abstract getAppName(): Observable<string>;
  abstract getLogo(): Observable<string>;
  abstract getVersion(): Observable<VersionInfoDto>;
}
